import type { FaireProductEntity } from "../../entity_types/product";

export const p_jhjhq8pq37: FaireProductEntity = {
  token: "p_jhjhq8pq37",
  type: "product",
  name: "Friend - 8 oz - 100% Soy Wax Candle\nScent: Tranquility",
  brandToken: "b_e74jkgmjc2",
  brandName: "Pavilion",
  imageUrl:
    "https://cdn.faire.com/fastly/21e39912147644924a1c355452a34f4d8887414600bdbed4e66422ccdeb34925.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ffd17e6c2dc1617b761459d474f50a24eb4a05d20ccb1ff8ec03589ab03c922.jpeg",
    "https://cdn.faire.com/fastly/80f37f1408cabe6a44c5a31bbefe835741751577291eeb0f4af3127f566a848d.jpeg",
    "https://cdn.faire.com/fastly/6adda5c1001e18497106be8679b8f28bb3a8a7d3bb7497f5a22ea3326a7a0c57.jpeg",
    "https://cdn.faire.com/fastly/d8007604bcbcd050f51f207c71533a894003e19aef541defa7e896a7a5379de2.jpeg",
    "https://cdn.faire.com/fastly/b6a92f1554929916d194bd14b5eef367a50b5f898d6f072ce7e41a4edd567f17.jpeg",
    "https://cdn.faire.com/fastly/784ec5e0095db765342ef94cc84dd7351c7b588ef27252faa11b97729bd58b6d.jpeg",
    "https://cdn.faire.com/fastly/c31b5ec44de5b6469ca148b4a2fd50ee72d8b5be03f4bd560c276bb1d769a688.jpeg",
    "https://cdn.faire.com/fastly/a35f53a8591c58d69a989b9f07e7dd0bfb4c2aa61c91ae288fe793b04c5e04a4.jpeg",
    "https://cdn.faire.com/fastly/7d7bb19d83cf78b239a995527b610e8cad9feed9597daddce4fb0c67e20ec834.jpeg",
    "https://cdn.faire.com/fastly/b47bfc9869751242104c3def72beb802924f698a6b2cf20d6ca9912adc6fbef3.jpeg",
  ],
  priceDollars: 10,
  description:
    'Organic wave-shaped handmade pottery-style stoneware vessel with 100% single cotton wick, lead, and nickel-free. The wax is tranquility scented and burns for up to 33 hours. Three foam feet pads are attached to the bottom of the relaxing candle to protect furniture surfaces. Measures 3.5" x 3.5" inches tall, holding 8 oz of 100% soy wax. Packaged safely in a die-cut box with a protective plastic wax cover. Orange, yellow, and green watercolor paint-inspired floral patterns with a yellow butterfly are accompanied by the "I Always Wished For A Friend Like You" glossy sentiment decal on the front side of this shiny ribbed cream vessel. The artwork was designed by artist AmyLee Weeks, who sees the beauty in everyday life. Wipe with a damp cloth. Always take care around an open flame - keep away from pets & children. Once the candle has burned out, repurpose it as a keepsake dish in the office, bathroom, or bedroom to hold small items such as paper clips, bobby pins, jewelry, coins, and mo',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:12.850Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
